'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var REDUCE_DOCUMENTS = exports.REDUCE_DOCUMENTS = 'REDUCE_DOCUMENTS';
var REDUCE_DOCUMENT_QUERY_ELEMENT = exports.REDUCE_DOCUMENT_QUERY_ELEMENT = 'REDUCE_DOCUMENT_QUERY_ELEMENT';
var REDUCE_SHAREABLE_DOCUMENTS = exports.REDUCE_SHAREABLE_DOCUMENTS = 'REDUCE_SHAREABLE_DOCUMENTS';